export const exportParams = [
  {
    label: '收款状态',
    key: 'receivableStates',
    value: '',
    matchValue: '',
  },
  {
    label: '应收时间',
    key: 'times',
    value: '',
    matchValue: '',
  },
  {
    label: '完成时间',
    key: 'completeTime',
    value: '',
    matchValue: '',
  },
  {
    label: '付款方类型',
    key: 'customerType',
    value: '',
    matchValue: '',
  },
  {
    label: '客户类型',
    key: 'customerInfoType',
    value: '',
    matchValue: '',
  },
  {
    label: '付款方',
    key: 'customerId',
    value: '',
    matchValue: '',
    type: 'select',
  },
  {
    label: '所属司管',
    key: 'driverManagerId',
    value: '',
    matchValue: '',
    type: 'select',
  },
  {
    label: '车牌号',
    key: 'carId',
    value: '',
    matchValue: '',
  },
  {
    label: '来源单类型',
    key: 'sourceOrderType',
    value: '',
    matchValue: '',
  },
  {
    label: '来源单ID',
    key: 'sourceOrderId',
    value: '',
    matchValue: '',
    type: 'input',
  },
  {
    label: '收款内容',
    key: 'content',
    value: '',
    matchValue: '',
  },
  {
    label: '是否变更',
    key: 'changeState',
    value: '',
    matchValue: '',
  },
  {
    label: '是否减免金额',
    key: 'relieveState',
    value: '',
    matchValue: '',
  },
  {
    label: '应收ID',
    key: 'id',
    value: '',
    matchValue: '',
    type: 'input',
  },
  {
    label: '所属部门',
    key: 'deptIdList',
    value: '',
    matchValue: '',
  },
  {
    label: '车源方',
    key: 'providerId',
    value: '',
    matchValue: '',
  },
  {
    label: '支付方式',
    key: 'payMethod',
    value: '',
    matchValue: '',
  },
]

export const CUSTOMER_INFO_TYPE_ENUM = {
  CUSTOMER: 1,
  TENANT: 2,
}
export const CUSTOMER_INFO_TYPE = {
  [CUSTOMER_INFO_TYPE_ENUM.CUSTOMER]: '个人',
  [CUSTOMER_INFO_TYPE_ENUM.TENANT]: '企业',
}
